var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('KeepAlive',{attrs:{"exclude":['Login'],"include":_vm.allowedToCache}},[_c('RouterView')],1),(_vm.$route.path !== '/login')?_c('NavigationMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }